var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"element--progress"}},[(_vm.activeSubPartId === _vm.subPartId)?_c('ElementProgress',{attrs:{"min":0.0,"max":1.0,"progress":_vm.progressValue}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }